import { Chip, Tooltip } from '@mui/material'
import mapping from 'atoms/Icon/mapping'
import { ROUTES } from 'routing/routes'

export interface InstallationTagProps {
  installationId?: string
}

export default function InstallationTag(props: InstallationTagProps) {
  const handleOpenInstallation = () => {
    window.open(`${ROUTES.INSTALLATIONS}/${props.installationId}`, '_blank')
  }

  if (!props.installationId) {
    return null
  }

  return (
    <Tooltip title={`Installation`}>
      <Chip
        size="medium"
        onClick={(e: any) => {
          e.preventDefault()
          handleOpenInstallation()
        }}
        label={mapping['Installation']}
      />
    </Tooltip>
  )
}
